"use strict";

var _taggedTemplateLiteral = require("/Users/satoshi/Documents/botlogy/projects/Ikitsuke-clinic/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n\n  font-size: var(--font-size-large);\n  color: var(--color-grey-dark-2);\n\n  padding-bottom: 1.5rem;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  min-width: 80vw;\n  max-width: 100rem;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  max-height: 90%;\n  overflow-y: scroll;\n  max-width: 90%;\n  outline: none;\n  padding: 2rem;\n  background-color: #fff;\n\n  // default paper style\n  box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.2),\n    0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 2px 1px -1px rgba(0, 0, 0, 0.12);\n  border-radius: 4px;\n\n  position: relative;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = __importDefault(require("styled-components"));

exports.StyledPaperDiv = styled_components_1.default.div(_templateObject());
exports.StyledModalContentDiv = styled_components_1.default.div(_templateObject2());
exports.StyledModalTitle = styled_components_1.default.h2(_templateObject3());